/**
 * =============================================================================
 * USE DEBOUNCE HOOK
 * =============================================================================
 * 
 * Debounce a value to prevent excessive API calls
 * 
 * @fileoverview Debounce hook utility
 * @author FinMatrix Development Team
 * @version 1.0.0
 */

import { useState, useEffect } from 'react';

export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

